<template>
  <div class="tbb-activities w-full">
    <div class="sm:flex justify-between">
      <h2 class="mb-0">Activity</h2>
      <div class="pb-2">Completed Hands-on: <span v-if="loadingTotal">Loading...</span><span v-else>{{ minutesToHoursAndMinutes(totalHandsOn) }}</span></div>
    </div>
    <p>See the key actions you've taken over time.</p>
    <div class="sm:flex justify-between items-end mb-10">
      <div class="flex items-end w-full sm:pr-10 mb-6 sm:mb-0">
        <div class="w-full">
          <label class="text-sm">
            Date Range:
          </label>
          <input id="activities-search-datepicker" type="text">
        </div>
        <div>
          <button class="btn border-0" @click="clearDatePicker">X</button>
        </div>
      </div>
      <button :class="completedOnly ? 'btn btn-primary' : 'btn'" @click="toggleCompletedOnly">{{ completedOnly ? 'Showing' : 'Show' }} Completed</button>
    </div>
    
    <list
        class="user-activity-list"
        :endpoint="`/api/user-activity/25?${[completedOnly ? 'completed=true' : '', start ? `start=${start}` : '', end ? `end=${end}` : ''].filter(Boolean).join('&')}`"
        list-type="user-activity"
        :paginate="true"
        :no-items="noItems"
    ></list>
  </div>
</template>

<script>
import flatpickr from 'flatpickr'
import axios from "axios";
import moment from 'moment';

export default {
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    noItems: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      loadingTotal: false,
      totalHandsOn: 0,
      completedOnly: false,
      start: null,
      end: null,
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    // get completed from url completed get parameter
    this.completedOnly = urlParams.get('completed') === 'true';

    const start = urlParams.get('start') ? moment(urlParams.get('start')).format('YYYY-MM-DD') : null;
    const end = urlParams.get('end') ? moment(urlParams.get('end')).format('YYYY-MM-DD') : null;
    if ((!start && !end) || (start && end)) {
      // must have both dates selected or neither
      this.start = start
      this.end = end
    }
    this.datePicker = flatpickr('#activities-search-datepicker', {
      altInput: true,
      altFormat: "F j, Y",
      dateFormat: "Y-m-d",
      defaultDate: [
        this.start || undefined,
        this.end || undefined
      ],
      mode: "range",
      onChange: this.handleDateChange
    })
    
    this.fetchCompletedActivities();
  },
  methods: {
    fetchCompletedActivities() {
      this.loadingTotal = true;
      // Fetch the completed activities from the API with super high limit to get all activities
      axios
        .get(`/api/user-activity/999999999?${['completed=true', this.start ? `start=${this.start}` : '', this.end ? `end=${this.end}` : ''].filter(Boolean).join('&')}`)
        .then(response => {
          const activities = response.data?.data?.data || [];
          this.totalHandsOn = activities.reduce((total, activity) => {
            return total + (!!activity.entity.total_hands_on ? (this.parseTimeToMinutes(activity.entity.total_hands_on) || 0) : 0);
          }, 0);
          this.loadingTotal = false;
        })
        .catch(error => {
          console.log(error);
          this.loadingTotal = false;
        });
    },

    toggleCompletedOnly() {
      this.completedOnly = !this.completedOnly;
      const url = new URL(window.location);
      url.searchParams.set('completed', this.completedOnly);
      window.history.pushState({}, '', url);
    },

    handleDateChange(event) {
      if ((!event[0] && event[1]) || (event[0] && !event[1])) {
        // must have both dates selected or neither
        return;
      }
      this.start = event[0] ? moment(event[0]).format('YYYY-MM-DD') : null;
      this.end = event[1] ? moment(event[1]).format('YYYY-MM-DD') : null;
      const url = new URL(window.location);
      if (this.start) {
        url.searchParams.set('start', this.start);
      } else {
        url.searchParams.delete('start');
      }
      if (this.end) {
        url.searchParams.set('end', this.end);
      } else {
        url.searchParams.delete('end');
      }
      window.history.pushState({}, '', url);
      this.fetchCompletedActivities()
    },

    clearDatePicker() {
      this.datePicker.clear();
    },

    parseTimeToMinutes(timeString) {
      let totalMinutes = 0;

      const hoursMatch = timeString.match(/(\d+)\s*(hr|hrs|hour|hours)/i);
      const minutesMatch = timeString.match(/(\d+)\s*(min|mins|minute|minutes)/i);

      if (hoursMatch) {
        totalMinutes += parseInt(hoursMatch[1]) * 60;
      }

      if (minutesMatch) {
        totalMinutes += parseInt(minutesMatch[1]);
      }

      return totalMinutes;
    },

    minutesToHoursAndMinutes(minutes) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = Math.round(minutes % 60);

      return `${hours} hr${hours > 1 ? 's' : ''}${!!remainingMinutes ? ` ${remainingMinutes} min${remainingMinutes > 1 ? 's' : ''}` : ''}`;
    }
  }
};
</script>
